import { IconCrane } from '@tabler/icons-react';
import { Control, FieldValues, Path } from 'react-hook-form';

import { FormField } from '@/components/ui/form';
import { ToggleGroup } from '@/components/ui/toggle-group';
import { parseVesselGear } from '@/lib/url-param-helpers';

import { InputWrapper } from './Inputs';
import { ModeToggleGroupItem } from './ModeSelector';

export const VESSEL_GEAR_FIELD_ID = 'vesselGear';

interface VesselGearFieldProps<T extends FieldValues> {
    control: Control<T>;
    name: Path<T>;
}

export function VesselGearField<T extends FieldValues>({ control, name }: VesselGearFieldProps<T>) {
    return (
        <FormField
            control={control}
            name={name}
            render={({ field }) => (
                <InputWrapper id={VESSEL_GEAR_FIELD_ID} label="Vessel gear" className="w-auto self-start">
                    <ToggleGroup
                        id={VESSEL_GEAR_FIELD_ID}
                        type="single"
                        className="bg-frGrey-800 rounded-full w-fit"
                        value={parseVesselGear(field.value) ?? 'all'}
                        onValueChange={(value: string | null) => {
                            // Radix reports an empty value when the active option is clicked again
                            if (!value) {
                                return;
                            }

                            field.onChange(value === 'geared' ? 'geared' : '');
                        }}
                        tabIndex={0}
                    >
                        <ModeToggleGroupItem value="all" aria-label="All vessels" className="px-4">
                            All vessels
                        </ModeToggleGroupItem>
                        <ModeToggleGroupItem value="geared" aria-label="Geared only" className="px-4">
                            <IconCrane className="h-4 w-4 mr-1" stroke={1.5} />
                            Geared only
                        </ModeToggleGroupItem>
                    </ToggleGroup>
                </InputWrapper>
            )}
        />
    );
}
